import mixpanel from 'mixpanel-browser'

// The `mixpanel` singleton is read as the `Vue.mixpanel` static (by auth.js / the bad_request interceptor);
// main.js sets it on the `Vue` compat global once installed (CP Vue 3: `app.use()` passes the app, not that
// global). Consumers guard on `Vue.mixpanel` being undefined, so when no token is configured it stays unset.
export { mixpanel }

export default {
  install (app, options) {
    if (!options.token) {
      return false
    }

    // CP2.1: server `mixpanel` SDK -> `mixpanel-browser`. init() configures the singleton
    // (returns void), so expose the singleton as Vue.mixpanel (it has .track / .people / .identify).
    mixpanel.init(options.token, options)
    mixpanel.responseBodyToMixpanelValue = responseBodyToMixpanelValue

    app.mixin({
      mounted () {
        this.$mixpanel = mixpanel
      }
    })
  }
}

/**
 * Mixpanel property value is <= 256 so we need to ensure body length doesn't exceed that
 * Additionally, if the body is an error message, start the value at that point so we may capture a more descriptive value
 * @param {*} body
 * @param {*} length
 */
export function responseBodyToMixpanelValue (body, length = 255) {
  let errMsgFlag = '<div id="summary">'
  if (body && typeof body === 'object') {
    return JSON.stringify(body).substr(0, length)
  }
  let bodyString = String(body)
  let bodyErrorParsed = body.match(errMsgFlag)
  // Is the body an error message from Django? If so, start body at that point
  if (bodyErrorParsed) {
    let substrStartAt = bodyErrorParsed.index + errMsgFlag.length
    bodyString = bodyString.substr(substrStartAt)
  }
  return bodyString.substr(0, length)
}
